/* Collection is stored as:
	[
		{
			id: getNewId(),
			cardId: 'beerdiertje',
			atPlace: 'potted plant',
			atDate: new Date(),
			traded: 0,
			score: 6
		},
	]
*/

import Cards from '../assets/cards/cards';
import { getNewId } from '../utils/Id';


export const getCollection = () => JSON.parse(localStorage.getItem('collection')) ?? [];

export const getCollectionCards = () => getCollection().map((value) => value.cardId);

export const getSortedCollection = () => {
	const collection = [];

	Cards.forEach((item) => {
		getCollection()
			.filter((card) => card.cardId === item.id)
			.forEach((card) => {
				collection.push(card);
			});
	});

	return collection;
};

export const saveCollection = (newCollection) =>
	localStorage.setItem('collection', JSON.stringify(newCollection));

export const getCollectionCount = () => getCollection().length;

export const isCardInCollection = (cardId) =>
	getCollection().filter((card) => card.cardId === cardId).length > 0;

export const searchCardByCardId = (cardId) =>
	getCollection().filter((card) => card.cardId === cardId)[0];

export const getCollectedCardIds = () => new Set(getCollection().map((card) => card.id));

export const addToCollection = (cardId, atPlace, score) => {
	const collection = getCollection();
	collection.push({
		id: getNewId(),
		cardId,
		atPlace,
		atDate: new Date(),
		score
	});
	saveCollection(collection);
};

export const updateCardScore = (cardId, score) => saveCollection(getCollection().map((card) => {
	if (card.id === cardId) card.score = score;
	return card;
}));

export const addTradedCardToCollection = (card) => {
	const collection = getCollection();
	if (card.traded) {
		card.traded += 1;
	} else {
		card.traded = 1;
	}
	collection.push(card);
	saveCollection(collection);
}

export const getCollectionCardById = (id) => getCollection().find((card) => card.id === id);

export const removeFromCollection = (cardId) => saveCollection(getCollection().filter(card => card.id !== cardId));
